export default __webpack_public_path__ + "static/summer_containers60-f1ccd8241554634e8605561e86d6b71d.webp";